<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="text-center border-0">Representantes</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in commercials" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <a @click.stop="edit(row)" >{{ row.user.name }}</a>
        </td>
        <td class="td-3">{{ row.user.email }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="td-2 text-center">{{ row.count_representatives }}</td>
        <td class="td-2">
          <commercial-buttons :commercial="row"></commercial-buttons>
        </td>
      </tr>
      <tr v-if="commercials.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum membro cadastrado.</td>
      </tr>
    </tbody>
    <commercial-imports/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CommercialButtons from './CommercialButtons.vue';
import CommercialImports from './CommercialImports.vue';
import { _EDIT_COMMERCIAL_ } from './CommercialModel';

export default {
  name: 'commercial-table',
  components: {
    CommercialButtons,
    CommercialImports,
  },
  props: {
    commercials: {
      type: Array,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    edit(row) {
      this.setToggle({ type: 'edit_commercial_modal', bool: true });
      Events.$emit(_EDIT_COMMERCIAL_, row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
